var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Component } from 'vue-property-decorator';
import LicenseService from "../../api/LicenseService";
import SupplierOrganService from '../../api/SupplierOrganService';
import Header from "./components/Header.vue";
import { Loading } from 'element-ui';
import _ from 'lodash';
import AddDialog from './components/AddDialog.vue';
import ApplyClientsDialog from '../businessgoodsprice/components/ApplyClientsDialog';
import ApplySuppliersDialog from './components/ApplySuppliersDialog';
import ArtMsglist from "../../components/alert/ArtMsglist.vue";
var PurchaseList = (function (_super) {
    __extends(PurchaseList, _super);
    function PurchaseList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.companyInfo = {};
        _this.listData = [];
        _this.total = 0;
        _this.selectRows = [];
        _this.tableHeight = 300;
        return _this;
    }
    PurchaseList.prototype.created = function () {
        this.service = SupplierOrganService.getInstance();
        this.licenseService = LicenseService.getInstance();
        this.getCompanyInfo();
    };
    PurchaseList.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 280;
        }, 300);
    };
    PurchaseList.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    PurchaseList.prototype.getCompanyInfo = function () {
        var _this = this;
        this.licenseService.getCompanyInfo().then(function (res) {
            if (res.data.success) {
                _this.companyInfo = res.data.data;
            }
        });
    };
    PurchaseList.prototype.search = function (filter) {
        this.$refs.pagination.clear();
        if (_.isDate(filter.s_time)) {
            filter.s_time = filter.s_time.format('yyyy-MM-dd');
        }
        if (_.isDate(filter.e_time)) {
            filter.e_time = filter.e_time.format('yyyy-MM-dd');
        }
        this.filter = filter;
        this.getList();
    };
    PurchaseList.prototype.getList = function (pager) {
        var _this = this;
        pager = pager ? pager : this.$refs.pagination.getPage();
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = Object.assign({}, this.filter, pager);
        this.service.getList(params).then(function (res) {
            loadingInstance.close();
            _this.listData = res.data.data;
            _this.total = res.data.total;
            if (params.keyword_type == '1') {
                window._czc.push(["_trackEvent", '机构管理搜索类型', '机构管理搜索类型', '按客户名称搜索']);
            }
            else {
                window._czc.push(["_trackEvent", '机构管理搜索类型', '机构管理搜索类型', '按单号搜索']);
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    PurchaseList.prototype.setDefault = function (row) {
        var _this = this;
        this.$confirm("\u786E\u8BA4\u4FEE\u6539\u9ED8\u8BA4\u673A\u6784\u4E3A" + row.organ_name + "\uFF1F").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            var params = {
                organ_id: row.organ_id
            };
            _this.service.setDefault(params).then(function (res) {
                loadingInstance.close();
                _this.$message.success("设为默认成功");
                _this.getList();
                window._czc.push(["_trackEvent", '机构管理设为默认', '机构管理设为默认']);
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    PurchaseList.prototype.cancel = function (row) {
        var _this = this;
        this.$confirm("注销机构将会彻底删除机构相关信息，确认注销？").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            var params = {
                organ_ids: row.organ_id
            };
            _this.service.cancel(params).then(function (res) {
                loadingInstance.close();
                _this.$message.success("注销成功");
                _this.getList();
                window._czc.push(["_trackEvent", '机构管理注销', '机构管理注销']);
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    PurchaseList.prototype.applyClients = function (row) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            organ_id: row.organ_id
        };
        this.service.getBusiness(params).then(function (res1) {
            loadingInstance.close();
            var tmpRow = res1.data.data;
            var dialog = _this.$dialog(ApplyClientsDialog, {
                data: {
                    supplier_to_business_ids: tmpRow.supplier_to_business_ids || [],
                    group_ids: tmpRow.group_ids || [],
                    disabled: !_this.Root_PageAuth.BindClient,
                    descHtml: "\n                    \u4E00\u4E2A\u673A\u6784\u53EF\u4EE5\u7ED1\u5B9A\u591A\u4E2A\u5BA2\u6237\uFF0C\u4F46\u662F\u5728\u5177\u4F53\u5355\u636E\u4E2D\u4EC5\u53EF\u4EE5\u4F53\u73B0\u4E00\u4E2A\u673A\u6784\u540D\u79F0\n                    ",
                    requiredChooseNum: false,
                },
                showEmpty: true
            }, {
                title: "绑定客户",
                width: 640,
                height: 530
            });
            dialog.instance.$on("submit", function (res) {
                var loadingInstance = Loading.service({ fullscreen: true });
                var params = {
                    organ_id: row.organ_id,
                    business_info: JSON.stringify(res.business_info)
                };
                _this.service.bindBusiness(params).then(function (res) {
                    loadingInstance.close();
                    _this.$message.success("绑定客户成功");
                    _this.getList();
                    window._czc.push(["_trackEvent", '机构管理绑定客户', '机构管理绑定客户']);
                }).catch(function (err) {
                    loadingInstance.close();
                    _this.$message.error(err.msg || err.message);
                });
            });
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    PurchaseList.prototype.applySuppliers = function (row) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            organ_id: row.organ_id
        };
        this.service.getSupplier(params).then(function (res1) {
            loadingInstance.close();
            var tmpRow = res1.data.data;
            var dialog = _this.$dialog(ApplySuppliersDialog, {
                data: {
                    supplier_to_business_ids: tmpRow.supplier_upper_ids || [],
                    group_ids: tmpRow.category_ids || [],
                    disabled: !_this.Root_PageAuth.BindSupplier,
                    requiredChooseNum: false,
                }
            }, {
                title: "绑定供应商",
                width: 640,
                height: 530
            });
            dialog.instance.$on("submit", function (res) {
                var loadingInstance = Loading.service({ fullscreen: true });
                var params = {
                    organ_id: row.organ_id,
                    supplier_upper_info: JSON.stringify(res.business_info.map(function (v) {
                        return {
                            category_id: v.group_id,
                            is_set_category: v.is_set_group,
                            children: v.children
                        };
                    }))
                };
                _this.service.bindSupplier(params).then(function (res) {
                    loadingInstance.close();
                    _this.$message.success("绑定供应商成功");
                    _this.getList();
                    window._czc.push(["_trackEvent", '机构管理绑定供应商', '机构管理绑定供应商']);
                }).catch(function (err) {
                    loadingInstance.close();
                    _this.$message.error(err.msg || err.message);
                });
            });
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    PurchaseList.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    PurchaseList.prototype.add = function () {
        var _this = this;
        var instance = this.$dialog(AddDialog, {
            data: {}
        }, {
            title: "添加机构",
            width: 560,
            height: 600
        }).instance;
        instance.$on("add_supplierorgan:ok", function (data) {
            window._czc.push(["_trackEvent", '机构管理', '添加机构']);
            _this.getList();
        });
    };
    PurchaseList.prototype.viewOrgan = function (row) {
        var instance = this.$dialog(AddDialog, {
            data: {
                row: JSON.parse(JSON.stringify(row)),
                action: 'view'
            }
        }, {
            title: "查看机构",
            width: 560,
            height: 600
        }).instance;
    };
    PurchaseList.prototype.edit = function (row) {
        var _this = this;
        var instance = this.$dialog(AddDialog, {
            data: {
                row: JSON.parse(JSON.stringify(row)),
                action: 'edit'
            }
        }, {
            title: "编辑机构",
            width: 560,
            height: 600
        }).instance;
        instance.$on("edit_supplierorgan:ok", function () {
            window._czc.push(["_trackEvent", '机构管理', '编辑机构']);
            _this.getList();
        });
    };
    PurchaseList.prototype.enable = function () {
        var _this = this;
        if (!this.selectRows.length) {
            this.$message.error("请选择机构");
            return;
        }
        ;
        var errCount = this.selectRows.reduce(function (errCount, v) { return (v.status == 1 ? ++errCount : errCount); }, 0);
        if (errCount > 0) {
            this.$message.error("\u201C\u505C\u7528\u4E2D\u201D\u673A\u6784\u65B9\u53EF\u542F\u7528");
            return;
        }
        this.$confirm("请确认是否启用选中的机构？").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            var params = {
                organ_ids: _this.selectRows.map(function (v) { return v.organ_id; }).join(','),
                status: 1
            };
            _this.service.changeStatus(params).then(function (res) {
                loadingInstance.close();
                _this.$message.success("启用成功");
                _this.getList();
                window._czc.push(["_trackEvent", '机构管理启用', '机构管理启用']);
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    PurchaseList.prototype.unEnable = function () {
        var _this = this;
        if (!this.selectRows.length) {
            this.$message.error("请选择机构");
            return;
        }
        ;
        var errCount = this.selectRows.reduce(function (errCount, v) { return (v.status == 2 ? ++errCount : errCount); }, 0);
        if (errCount > 0) {
            this.$message.error("\u201C\u5DF2\u542F\u7528\u201D\u673A\u6784\u65B9\u53EF\u505C\u7528");
            return;
        }
        this.$confirm("请确认是否停用选中的机构？").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            var params = {
                organ_ids: _this.selectRows.map(function (v) { return v.organ_id; }).join(','),
                status: 2
            };
            _this.service.changeStatus(params).then(function (res) {
                loadingInstance.close();
                if (res.data.success) {
                    if (res.data.code == 50) {
                        var instance = _this.$dialog(ArtMsglist, {
                            data: {
                                msgData: res.data.data,
                            }
                        }, {
                            title: "提示",
                            width: 450,
                            height: 350
                        }).instance;
                    }
                    else {
                        _this.$message.success("停用成功");
                        _this.getList();
                    }
                }
                window._czc.push(["_trackEvent", '机构管理停用', '机构管理停用']);
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    PurchaseList = __decorate([
        Component({
            components: {
                'list-header': Header
            },
            computed: __assign({}, mapGetters({
                "user": "user",
                openedCodeData: 'openedCodeData'
            }))
        })
    ], PurchaseList);
    return PurchaseList;
}(Vue));
export default PurchaseList;
